import React from 'react'
import './Footer.css';
const Footer = () => {
  return (
    <footer className='footer'>
        copyright &#169; 2024 Mohammed Sameer. All right received.
    </footer>
  )
}

export default Footer
